import React, { useEffect, useRef, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { useNotif } from 'contexts/NotifContext';

import { formatListFieldUser } from 'utils/functions';
import { DOMAINCONFIG, USERS } from 'utils/rest';

import { Text } from 'components/DataDisplay';
import { FormSection } from 'components/FormSection';
import { Button } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { ListField } from 'components/ListField';
import Loading from 'components/Loading';

const NewsletterContainer = () => {
  const { notify } = useNotif();
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUser] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const timerRef = useRef(null);

  const fetchUsers = async search => {
    const body = { search };
    const found = await USERS.getPaginated(body);
    setAllUser(found?.result?.map(formatListFieldUser) || []);
    setLoaded(true);
  };

  const pollUsers = query => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      fetchUsers(query);
    }, 500);
  };

  const handleChange = value => {
    setUsers(value);
  };

  const send = async () => {
    const result = await DOMAINCONFIG.sendNewsletter(users.map(el => el.email));

    if (!result) {
      return notify({
        message: "Echec de l'envoi de la newsLetter",
        variant: 'error'
      });
    }
    return notify({
      message:
        "Demande d'envoie de newsletter prise en compte, cela peux prendre quelques instants",
      variant: 'success'
    });
  };

  useEffect(() => {
    if (!loaded) {
      pollUsers('');
    }
    // eslint-disable-next-line
  }, [loaded]);

  if (!loaded) {
    return (
      <Container>
        <Loading loading />
      </Container>
    );
  }

  return (
    <Container>
      <Row spacing={5}>
        <Item style={{ padding: '20px 0px' }}>
          <Text fontWeight={500} fontSize="21px">
            Envoyer la newsletter
          </Text>
        </Item>
        <Item>
          <Text fontWeight={600} fontSize="12px">
            Laissez le champs utilisateurs ci dessous vide, pour envoyer l’email
            à tous les utilisateurs du domaine.
          </Text>
        </Item>
      </Row>
      <Row spacing={5}>
        <Item xs={10}>
          <FormSection title="Utilisateurs">
            <Item style={{ maxWidth: '600px' }}>
              <ListField
                options={allUsers}
                searchOptionsKeys={['email']}
                values={users}
                onChange={handleChange}
                actionTxt="Ajouter un utilisateur"
                hideKeys={['_id']}
                deleteAction
                variant="asyncAutoComplete"
                onChangeInput={value => {
                  pollUsers(value);
                }}
              />
            </Item>
          </FormSection>
        </Item>
      </Row>
      <Row spacing={5}>
        <Item>
          <Button
            onClick={send}
            variant="contained"
            style={{ padding: '10px 16px' }}
          >
            <ChevronRightIcon />
            &nbsp; Envoyer l’email
          </Button>
        </Item>
      </Row>
    </Container>
  );
};

export default NewsletterContainer;
